
import { useEffect } from "react";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Hero } from "@/components/home/Hero";
import { Features } from "@/components/home/Features";
import { IntegrationLogos } from "@/components/home/IntegrationLogos";
import { TemplateShowcase } from "@/components/home/TemplateShowcase";
import { TestimonialSection } from "@/components/home/TestimonialSection";
import { Pricing } from "@/components/home/Pricing";
import { CTASection } from "@/components/home/CTASection";

const Index = () => {
  // Smooth scroll to sections when navigating with hash links
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash) {
        const element = document.getElementById(window.location.hash.substring(1));
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 100, // Offset for fixed header
            behavior: "smooth"
          });
        }
      }
    };

    // Handle hash on initial load
    if (window.location.hash) {
      setTimeout(handleHashChange, 100);
    }

    // Add event listener for hash changes
    window.addEventListener("hashchange", handleHashChange);
    
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <Features />
        <IntegrationLogos />
        <TemplateShowcase />
        <TestimonialSection />
        <Pricing />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
